function convertCompletionToToggle(records, userIndex) {

    const recordsArray = []
    
    for (let i=0;i < records.length; i++) {
        let completionStatus = records[i]?.completions[userIndex]?.done;
        if (completionStatus) {
            recordsArray.push(1);
        } else{
            recordsArray.push(2);    
        }
        
    }
    return recordsArray; 
}

export default convertCompletionToToggle;